const None = 'None';
const Error = 'Error';
const Success = 'Success';
const PartialSuccess = 'PartialSuccess';

const PublishStatusType = Object.freeze({
    [None]: 0,
    [Error]: 1,
    [PartialSuccess]: 2,
    [Success]: 3,
});

export const PublishStatusClassNames = Object.freeze({
    0: 'status-none',
    1: 'status-error',
    2: 'status-partial',
    3: 'status-success',
});

export default PublishStatusType;
